import { Component, OnInit } from '@angular/core';
import { ParentDataService } from '../../../service/parent-data.service';
import { LocalStorageService } from "ng2-webstorage";

@Component({
  selector: 'parent-home',
  templateUrl: './parent-home.component.html',
  styleUrls: ['./parent-home.component.css']
})
export class ParentHomeComponent implements OnInit {

  public children: any
  public loading: boolean = true
  public spinnershow: boolean = false;
  constructor(private _parentData: ParentDataService, private localStorage: LocalStorageService) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/parent-home/parent-home.component.ts